<template>
    <b-modal
        class="clean-modal new-organization-modal"
        :id="`organization-edit-modal-${organizationId}`"
        :ref="`organization-edit-modal-${organizationId}`"
        :title="$t('organization.edit_organization')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        :ok-disabled="title === null"
        @ok="onOk"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal"
        size="sm">
        <b-alert
            v-if="hasError"
            variant="danger"
            show>
            {{ $t('organization.organization_name_is_mandatory') }}
        </b-alert>

        <b-form-input v-model="title"></b-form-input>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-organization-edit-modal-component',
    props: {
        organizationId: Number,
        organisationName: String,
    },
    data() {
        return {
            title: this.organisationName,
            hasError: false,
        };
    },
    methods: {
        onOk() {
            this.hasError = this.title === null || this.title === '';

            if (!this.hasError) {
                const data = {
                    name: this.title,
                };

                this.alert.saving(
                    this.$t('organization.update_organization'),
                    this.$t('organization.organization_will_be_updated_please_wait_a_moment'),
                );

                this.axios.post(this.routes.organizationUpdate(this.organizationId), data).then(
                    (response) => {
                        this.$emit('update-organization-list', response.data);
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error, this.$t('organization.update_organization'));
                    },
                );
            }
        },
    },
};
</script>

<style scoped></style>
